export const RouteNames = {
  PATH_LOGIN: 'login',
  PATH_USER_MANAGEMENT: 'user-management',
  PATH_ADMIN: 'admin',
  PATH_EVENT: 'event',
}
